import { Reducer } from 'redux';

import { SuiteHeaderLoadDataAction } from '../../domains/suiteHeaderLoad/actions.types';

import { SuiteHeader } from './types';

export type SuiteHeaderAction = SuiteHeaderLoadDataAction;

const initialState: SuiteHeader = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<SuiteHeader, SuiteHeaderAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SUITE_HEADER.LOAD_DATA_PENDING':
      return { ...initialState, pending: true };
    case 'SUITE_HEADER.LOAD_DATA_FULFILLED':
      return { ...initialState, fulfilled: action.payload };
    case 'SUITE_HEADER.LOAD_DATA_REJECTED':
      return { ...initialState, rejected: action.payload.error };
    default:
      return state;
  }
};

export default reducer;
